import React from 'react'
import { bem } from '@argos/utils'

const cn = bem({ prefix: 'lc-', block: 'feedback-slider' })

const SliderTooltip = ({ value }) => (
  <div className={cn('tooltip')}>
    <span className='sr-only'>{value}</span>
    <div className={cn('tooltip-top')}>
      {value}
      <span className={cn('point')} />
    </div>
  </div>
)
export default SliderTooltip
